module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAAvElEQVQokcXQIQ7CQBCF4bcnIBAkoghCENTianBNsARZg+cMKBQHQJBQgSA0hHAGjoHmAgjcj3mirlvFJismM9/LZIIiHjCRtJY0kPSV9JB0jYEpUAGF6w6wBZYx8AhkwAmY1QLKGJi4ngO3WsAlFo6BEsi9QQHs28DUdeYbTNrCxP30/3DkwXbQzRVw9yXjoQc2wAI4AOdo6KEdMAT6DsijoPEJ6Dlg6oCyEUoKQCXpI+kt6enfDSG8mvAPZ9tvR2NPwtkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/general-icons/icon_edit.png
// module id = 49
// module chunks = 0